import { Component, computed, input } from '@angular/core';

import { colorClassNames, fontWeightClassnames, textClassNames } from './text.constants';
import { getTextColorClassname, getTextVariantClassname, getTextWeightClassname } from './text.helpers';

type RemovePrefix<S extends string, P extends string> = S extends `${P}${infer R}` ? R : S;

@Component({
  selector: '[educa-text]',
  template: '<ng-content></ng-content>',
  host: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '[class]': '[variantClassname(), colorClassname(), weightClassname()].join(" ") '
  }
})
export class EducaTextComponent {
  variant = input.required<RemovePrefix<(typeof textClassNames)[number], 'text-'>>();
  color = input<RemovePrefix<(typeof colorClassNames)[number], 'color-'>>();
  weight = input<RemovePrefix<(typeof fontWeightClassnames)[number], 'font-'>>();

  variantClassname = computed(() => getTextVariantClassname(this.variant()));
  colorClassname = computed(() => (this.color() ? getTextColorClassname(this.color()!) : ''));
  weightClassname = computed(() => (this.weight() ? getTextWeightClassname(this.weight()!) : ''));
}
